import { IUserManagerConfig } from '../Models/IUserManagerConfig';

export let _userManagerConfig: IUserManagerConfig | undefined;

export const UserManagerInitializer: React.FunctionComponent<IUserManagerConfig> = (props: IUserManagerConfig) => {
  _userManagerConfig = props;

  return <></>;
};
